// extracted by css-extract-rspack-plugin
var _1 = "TrGWnJWSck-Ah7uqpf7RMg--";
var _2 = "kgpc2GOUTTPrBbvKfodtQg--";
export { _1 as "rotated", _2 as "wrapper" }
